import * as React from 'react';
import Api, { doLogout } from 'domain/api';
import { call, put } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import * as actions from './actions';
import { ensureJounalEntry } from 'domain/journal/sagas';
import { yieldErrorNotification, yieldSuccessNotification } from 'lib/toasts';
import * as adapters from '../journal/adapters';
import { updateJournalEntryAction } from 'domain/journal/actions';

export function* ensureGetExtractedTableData(documentID) {
  try {
    const { data } = yield call(Api.getExtractedTableData, {
      documentID,
    });
    yield put({
      type: actions.getDocumentExtractedTableData.success,
      payload: data,
    });
    return data;
  } catch (err) {
    yield doLogout(actions.getDocumentExtractedTableData, err);
  }
}

// DA-19204: ensureGetExtractedTableFieldsMapping removed — field mapping is now
// fetched lazily via TanStack Query in the binding dropdown component

export function* ensureLearnExtractedTableFields({ documentID, data: { resolve, reject, ...restPayload } }) {
  /*
  [
  {
    "header": "string",
    "name": "string",
    "type": "string",
    "mandatory": false,
    "default": "string"
  }
] */
  try {
    // filter-out unbound fields represented as empty object
    const prepare = Object.fromEntries(Object.entries(restPayload).filter(([_, v]) => Object.keys(v).length !== 0));
    const payload = Object.entries(prepare).map(([key, { name, type, mandatory }]) => ({
      header: name,
      name: key,
      mandatory,
      type,
    }));

    const { data } = yield call(Api.learnExtractedTableFields, {
      documentID,
      data: payload,
    });

    yield put({
      type: actions.learnDocumentExtractedTableFieldsAction.success,
      payload: data,
    });

    yield call(ensureJounalEntry, documentID, false);
    yieldSuccessNotification(
      <FormattedMessage id="3WayMatching.toast.successBinded" defaultMessage="Document items binding updated" />,
    );

    resolve?.();
  } catch (err) {
    reject?.();
    yield doLogout(actions.learnDocumentExtractedTableFieldsAction, err);
  }
}
export function* ensureExtractLines({ documentID }) {
  try {
    const { data } = yield call(Api.extractLines, {
      documentID,
    });

    const jePayload = adapters.JEAdapter(data);

    yield put({
      type: actions.ExtractLinesAction.success,
    });

    yield put({
      type: updateJournalEntryAction.success,
      payload: jePayload,
    });
  } catch (err) {
    yieldErrorNotification(err?.response?.data);
    yield doLogout(actions.ExtractLinesAction, err);
  }
}
